import * as React from 'react';

import { IMemberSearch } from '@/client/legacy-shared-modules/search/search-types';
import type { MemberIndexViewableField } from '@/components/GlobalSearch/types';
import { UserHit } from '@/imports/ui/components/search/MemberHits';

import { ResultsListContainer } from '../results/ResultsListContainer';

export const MembersList: React.FC<{
  hits: IMemberSearch[];
  viewableAttributesField: MemberIndexViewableField;
  searchableAttributesField: string;
}> = ({ hits, viewableAttributesField, searchableAttributesField }) => {
  if (hits.length === 0) {
    return null;
  }

  return (
    <ResultsListContainer index="members">
      {hits.map((memberHit) => (
        <React.Fragment key={memberHit.objectID}>
          {UserHit(
            memberHit,
            viewableAttributesField,
            searchableAttributesField,
            'searchSidebar'
          )}
        </React.Fragment>
      ))}
    </ResultsListContainer>
  );
};
